import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

import { useMFEContext } from '~/components/MFEProvider';
import { getSelectedHostingId } from '~/utils/hosting/helpers';

import RenderCard from './RenderCard';

interface FTPAccessProps {
  hostingPlanId?: string;
  backReference?: string;
}

const FTPAccess: React.FC<FTPAccessProps> = ({
  hostingPlanId,
  backReference,
}) => {
  const { t } = useTranslation('hosting');
  const {
    //@ts-expect-error
    updateMFEContext,
  } = useMFEContext();

  // @ts-ignore
  const navigate = useNavigate();

  const handleUpdateHostingId = (id?: string) => {
    const hostingId = getSelectedHostingId(id, backReference);
    updateMFEContext(hostingId);
    navigate(`/ftp-access`);
  };

  return (
    <RenderCard
      title={t('hostingNova.ftpAccess')}
      action={
        <Button
          size="small"
          fullWidth
          variant="outlined"
          sx={{ mt: 1 }}
          onClick={() => handleUpdateHostingId(hostingPlanId)}
        >
          {t('hostingNova.manageBtn')}
        </Button>
      }
      tooltip={t('hostingNova.ftpTooltip')}
      dataTestId="ftp-access-card"
    />
  );
};

export default FTPAccess;
